import type {
  GpsReferenceOrigin,
  GVICameraPosesByFilename,
} from 'types/fde/aerospace/gviCameraPose'
import { RolodexEntryJson } from 'types/rolodex/rolodexEntries'
import { parseNumber, parseString } from 'utils/parsingHelpers'

import { GeckoEntryBase } from './geckoEntry'

function parseReferenceOrigin(value: unknown): GpsReferenceOrigin | undefined {
  if (value === null || typeof value !== 'object') return undefined
  const obj = value as Record<string, unknown>
  const latitude = parseNumber(obj.latitude)
  const longitude = parseNumber(obj.longitude)
  const altitude = parseNumber(obj.altitude)
  if (
    latitude === undefined ||
    longitude === undefined ||
    altitude === undefined
  )
    return undefined
  return { latitude, longitude, altitude }
}

/**
 * Camera poses for an Aerospace GVI inspection, keyed by image filename.
 */
export class GeckoAerospaceGVICameras extends GeckoEntryBase<
  {
    cameraPoses: GVICameraPosesByFilename
    referenceOrigin?: GpsReferenceOrigin
  },
  {
    'aerospace-gvi': string
  }
> {
  private constructor(json: RolodexEntryJson) {
    const recordData = json.data as Record<string, unknown>

    const raw = recordData.cameraPoses
    const cameraPoses: GVICameraPosesByFilename =
      raw !== null && typeof raw === 'object' && !Array.isArray(raw)
        ? (raw as GVICameraPosesByFilename)
        : {}

    super(
      json,
      {
        cameraPoses,
        referenceOrigin: parseReferenceOrigin(recordData.referenceOrigin),
      },
      {
        'aerospace-gvi': parseString(json.tags['aerospace-gvi']) ?? '',
      },
      {}
    )
  }

  public static CreateFromJSON(json: RolodexEntryJson) {
    return new GeckoAerospaceGVICameras(json)
  }
}
